const ES = {
    title: 'Cambiá tu',
    title2: 'contraseña',
    description: 'Generá una nueva contraseña para continuar.',
    helperText: 'Ten en cuenta que no pueden ser datos personales ni números consecutivos.',
    inputs: {
        password: {
            label: 'Ingresa tu nueva contraseña: ',
            placeholder: 'Ingresa tu contraseña nueva'
        },
        confirmPassword: {
            label: 'Confirmar contraseña: ',
            placeholder: 'Reescribe tu contraseña nueva'
        },
    },
    help: {
        title: 'Debe tener, al menos:',
        list: {
            0: '8 caracteres',
            1: 'Un carácter en minúscula',
            2: 'Un carácter en mayúscula',
            3: 'Un número',
            4: 'Un carácter especial'
        }
    },
    changePassword: {
        success: 'Su nueva contraseña fue creada exitosamente.',
        error: 'Las contraseñas no coinciden.'
    },
    recover: {
        success: 'El usuario ha sido validado correctamente.',
        description: 'Por Favor, ingrese su nueva contraseña.'
    },
    // Onboarding flow
    titleCreate: 'Elige tu',
    titleCreate2: 'contraseña',
    inputsCreate: {
        password: {
            placeholder: 'Genera tu contraseña'
        },
        confirmPassword: {
            placeholder: 'Reescribe tu contraseña'
        }
    }
};

export default ES;
